import { EllipsisTooltip } from 'App/Map/PanelDetails/OverviewCharts/EllipsisTooltip'
import type { CurrentValuesDataInfo } from 'App/Map/PanelDetails/OverviewCharts/OverviewColumns'
import { periodTitle } from 'App/Map/PanelDetails/OverviewCharts/_utils/columnTitles'
import type { TColumn } from 'components/SummaryTable/SummaryTable.types'
import { translate } from 'i18n/i18n'
import { unitConverter } from 'utils/unitConverter/unitConverter'

export const almondHullSplitColumn = (): TColumn => ({
  title: (
    <EllipsisTooltip
      fullText={periodTitle(
        translate.phrases.banyanApp('Almond Hull Split'),
        translate.phrases.banyanApp('Nonpareil'),
      )}
    />
  ),
  dataIndex: 'almondHullSplit_date',
  key: 'almondHullSplit_date',
  width: 275,
  render: (value: Record<string, string>) =>
    value ? unitConverter.almondHullSplit(value[72]).valueWithSuffix() : translate.phrases.templates('-'),
  sorter: (a: CurrentValuesDataInfo, b: CurrentValuesDataInfo) =>
    a.almondHullSplit_date && b.almondHullSplit_date
      ? +new Date(a.almondHullSplit_date[72]) - +new Date(b.almondHullSplit_date[72])
      : -1,
})
